import { render } from "./apppages.vue?vue&type=template&id=46506ad3&scoped=true"
import script from "./apppages.vue?vue&type=script&lang=js"
export * from "./apppages.vue?vue&type=script&lang=js"

import "./apppages.vue?vue&type=style&index=0&id=46506ad3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46506ad3"]])

export default __exports__